export const META_CSV_GENERATION_STATUSES = {
  NOT_FOUND: 0,
  IN_PROGRESS: 1,
  COMPLETED: 2,
};

export const META_API_PLATFORM = 'meta_api';
